var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-icon',{class:{ disabled: _vm.disabled },attrs:{"size":"22","icon-size":"17","color":_vm.checkColor},on:{"click":_vm.emitClick}},[_vm._v("\n    "+_vm._s(_vm.checkIcon)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }